import { useState } from 'react';
export default function Img({ src, alt, ratio, priority, className }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={"img-wrap " + (className || "")} style={ratio ? { aspectRatio: ratio } : null}>
      {!loaded && <div className="skel img-skel" />}
      <img src={src} alt={alt || ""} loading={priority ? "eager" : "lazy"} decoding="async"
        onLoad={() => setLoaded(true)}
        className={"img-el" + (loaded ? " loaded" : "")} draggable={false} />
    </div>
  );
}
